import { readonly, shallowRef } from "vue";
import { createDeferredI18n } from "#/shared/composables/useI18n";
import fallbackMessages from "#/shared/i18n/frontend.filters.json";

export const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "filters", fallbackMessages });

const ready = shallowRef(false);
export const i18nReady = readonly(ready);

function markReady() {
  ready.value = true;
}

whenI18nReady.then(markReady);

export function t(key, values) {
  return values ? i18n.global.t(key, values) : i18n.global.t(key);
}
